import { createSlice } from "@reduxjs/toolkit";
import { getContacts } from "./_contactAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const contactList = createSlice({
  name: "contactList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getContacts.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getContacts.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getContacts.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
